import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	findFittingList,
	changeFittingActivePage,
	findOrderer,
	findFittingRecord,
	openFittingRecordModal
} from '../actions';

function generateField(detailsNeedBespoke) {

	let fittingFields = {
		serial_no: '項次',
		display_name: '警義消別',
		category: '群組',
		firefighter_division: '大隊',
		firefighter_squadron: '分隊',
		firefighter_title: '職稱',
		firefighter_name: '姓名'
	};

	for (var i = 0; i < detailsNeedBespoke.size; i++) {
		let detail = detailsNeedBespoke.get(i);

		if ("Y" === detail.get('fitting_color')) {
			let key1 = '_' + detail.get('order_detail_id') + "t_color_display";
			let value1 = detail.get('customer_gear_name') + "顏色";
			fittingFields[key1] = value1;
		}
		if ("Y" === detail.get('fitting_size')) {
			let key2 = '_' + detail.get('order_detail_id') + "t_sizing_display";
			let value2 = detail.get('customer_gear_name') + "尺寸";
			fittingFields[key2] = value2;
		}
	}

	return fittingFields;
}

function checkDisableEdit(roles) {
	return !(roles.includes("ROLE_FIREFIGHTER_FITTING_CRUD"));
}

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fittingReducer', 'orderId']),
	data: state.getIn(['fittingListReducer', 'fittingList']),
	activePage: state.getIn(['fittingListReducer', 'activePage']),
	itemPerPage: state.getIn(['fittingListReducer', 'itemPerPage']),
	totalPage: state.getIn(['fittingListReducer', 'totalPage']),
	searchWord: state.getIn(['fittingListReducer', 'searchWord']),
	pagingMaxButtons: 5,
	fields: generateField(state.getIn(['fittingReducer', 'detailsNeedBespoke'])),
    keys: ['suit_id', 'orderer_id'],
	searchKeys:[
		'firefighter_gear_orderers.category', 
		'firefighter_gear_orderers.firefighter_name',
		'firefighter_gear_orderers.firefighter_division',
		'firefighter_gear_orderers.firefighter_squadron', 
		'firefighter_gear_suits.serial_no' ],
    disableAdd: true,
	disableEdit:checkDisableEdit(state.getIn(['authReducer', 'roles']).toJS()),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: (pagingData) => {
		dispatch(findFittingList({orderId: ownProps.orderId}, pagingData));
	},
	changeActivepage: (pagingData, searchData) => {
		dispatch(changeFittingActivePage(pagingData));
		dispatch(findFittingList({orderId: ownProps.orderId}, pagingData, searchData));
	},
	handleEdit:(pk) => {
		dispatch(findFittingRecord({orderId: ownProps.orderId}, pk));
		dispatch(findOrderer({orderId: ownProps.orderId}, pk));
		dispatch(openFittingRecordModal());
	},
	search:(pagingData, searchData) => {
		dispatch(findFittingList({orderId: ownProps.orderId}, pagingData, searchData));
	}
})

const FittingRecordListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default FittingRecordListContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingRecordListContainer.jsx